import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useEffect, } from 'react';
import GetInTouch from './GetInTouch';
import { useParams } from 'react-router-dom';
export default function Oferta() {
  useEffect(() => {
    document.title = 'Maciej Głąb - Oferta';
  }, []);
  const { local = 'olkusz' } = useParams();
  return (
    <motion.section
      className="py-24 bg-[#0f0a07] text-[#f5f1ea]"
      id="oferta"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-20">

        <h2 className="text-4xl font-serif text-center mb-16 text-[#c6a15b]">
          Oferta dla obiektów
        </h2>

        <p className="text-center max-w-3xl mx-auto mb-20 opacity-90 leading-relaxed">
          Prowadzę profesjonalne ceremonie saunowe dla hoteli, stref SPA
          i obiektów saunowych. Tworzę dopracowane seanse, które podnoszą
          prestiż miejsca i budują doświadczenie gości.
        </p>

        {/* KAFELKI */}
        <div className="grid md:grid-cols-3 gap-8 mb-24">

          {/* Kafelek 1 */}
          <div className="bg-[#14100d] border border-[#2a1f17] rounded-2xl p-10 text-center hover:border-[#c6a15b] transition">
            <h3 className="text-xl font-semibold mb-6 text-[#c6a15b]">
              Pakiet podstawowy
            </h3>
            <p className="text-4xl font-serif mb-6">
              200 zł
            </p>
            <p className="opacity-80 leading-relaxed">
              3 profesjonalne seanse saunowe prowadzone jednego dnia
              dla gości obiektu.
            </p>
          </div>

          {/* Kafelek 2 */}
          <div className="bg-[#14100d] border border-[#2a1f17] rounded-2xl p-10 text-center hover:border-[#c6a15b] transition">
            <h3 className="text-xl font-semibold mb-6 text-[#c6a15b]">
              Seanse tematyczne
            </h3>
            <p className="text-lg mb-6 opacity-90">
              Indywidualna wycena
            </p>
            <p className="opacity-80 leading-relaxed">
              Ceremonie z dopasowaną muzyką, narracją i kompozycją zapachową
              pod charakter obiektu.
            </p>
          </div>

          {/* Kafelek 3 */}
          <div className="bg-[#14100d] border border-[#2a1f17] rounded-2xl p-10 text-center hover:border-[#c6a15b] transition">
            <h3 className="text-xl font-semibold mb-6 text-[#c6a15b]">
              Stała współpraca
            </h3>
            <p className="text-lg mb-6 opacity-90">
              Warunki ustalane indywidualnie
            </p>
            <p className="opacity-80 leading-relaxed">
              Regularne ceremonie zwiększające frekwencję
              i atrakcyjność oferty saunowej.
            </p>
          </div>

        </div>

        <div className="text-center">
          <Link
            to={`/${local}/kontakt`}
            className="border border-[#c6a15b] px-10 py-4 rounded-xl text-[#c6a15b] hover:bg-[#c6a15b] hover:text-[#1a140f] transition text-lg font-medium"
          >
            Skontaktuj się w sprawie współpracy
          </Link>
        </div>

      </div>

      <div className="mt-24">
        <GetInTouch />
      </div>

    </motion.section>
  );
}
